import { normalizeMultilineAddress } from '../multiline-address/multiline-address-normalize-value';
export const bookingsAddressViewer = {
    normalizeLoadedValue: normalizeMultilineAddress
};

//# sourceMappingURL=definition-viewer.js.map